import { z } from "zod";

const translationSchema = z.object({
  locale: z.string().min(1, "Locale is required"),
  name: z.string().optional().or(z.literal("")),
  description: z.string().optional().or(z.literal("")),
});

const optionSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export const BrandFormSchema = z
  .object({
    emailReceiver: z.string().min(1, "Email receiver is required").email("Invalid email format"),
    emailSender: z.string().min(1, "Email sender is required").email("Invalid email format"),
    replyToEmail: z.string().email("Invalid email format").or(z.literal("")),
    communicationPolicy: z.string().min(1, "Communication policy is required"),
    privacyPolicy: z.string().min(1, "Privacy policy is required"),
    widgetLoyalty: z.boolean().default(false),
    widgetUrl: z
      .string()
      .max(2048, "Widget URL is too long (max 2048 characters)")
      .optional()
      .default(""),
    idTierAgency: z
      .string()
      .max(255, "Agency ID is too long (max 255 characters)")
      .optional()
      .default(""),
    idTierCompany: z
      .string()
      .max(255, "Company ID is too long (max 255 characters)")
      .optional()
      .default(""),
    enableEmailChange: z.boolean().default(false),
    sendWelcomeEmail: z.boolean().default(false),
    useExternalTier: z.boolean().default(false),
    useExternalAuthSystem: z.boolean().default(false),
    translationsList: z.array(translationSchema).optional().default([]),
    managedByOptions: z.array(optionSchema),
    usedByOptions: z.array(optionSchema),
  })
  .superRefine((data, ctx) => {
    if (data.widgetLoyalty) {
      if (!data.widgetUrl || data.widgetUrl.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Widget fields required",
          path: ["widgetUrl"],
        });
      }
      if (!data.idTierAgency || data.idTierAgency.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Widget fields required",
          path: ["idTierAgency"],
        });
      }
      if (!data.idTierCompany || data.idTierCompany.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Widget fields required",
          path: ["idTierCompany"],
        });
      }
    }
  });
